<template>
  <div style="width: 100%;">
    <v-container fluid>
      <span class="d-flex flex-row align-baseline mb-3">
        <v-btn class="mr-2" fab @click="()=>this.$router.go(-1)" x-small><v-icon>mdi-chevron-left</v-icon></v-btn>
        <h1>Track Tags</h1>
      </span>
      <span v-if="loader">
        <v-progress-circular
          indeterminate
          color="green"
        ></v-progress-circular>
      </span>
      <span v-else>
        <v-card outlined>
          <v-card-text>
            <h2>Tag: {{ tag }}</h2>
            <v-btn class="mt-3" block color="warning" :loading="scanLoader" @click="scan" x-large>SCAN</v-btn>
          </v-card-text>
        </v-card>
        <v-card class="mt-3" outlined v-if="selectedItem">
          <v-card-text>
            <span class="d-flex flex-row justify-space-between align-baseline">
              <h3>
                <v-chip>PL-{{selectedItem.id }}</v-chip>
                 {{selectedItem.Brand?`${selectedItem.Brand.name} `:''}}
                 {{selectedItem.name}}
               </h3>
              <v-btn fab color="error" @click="selectItem(null)" x-small><v-icon>mdi-close</v-icon></v-btn>
            </span>
            <span class="d-flex flex-row justify-space-between" style="text-align: left; background-color: rgba(0,0,0,0.05); padding: 10px; margin-top: 6px; border-radius: 7px;">
              <div class="d-flex flex-column justify-space-between">
                <span class="d-flex flex-column align-start">
                  <span><b>SP: ${{selectedItem.regularPrice}}</b>, <span v-if="isAllowed('product', 'viewCostPrice')">PP: ${{selectedItem.salePrice}}</span></span>
                  <span><b>QTY: {{selectedItem.ProductLocationJoins.find(x => x.userBranch===true)?selectedItem.ProductLocationJoins.find(x => x.userBranch===true).available:0}}</b><span v-if="getGlobalValue('showBranchQuantities')==='true'">[{{selectedItem.ProductLocationJoins.reduce((total, curr) => total+parseInt(curr.available), 0)}}]</span></span>
                  <span>ID: {{selectedItem.id}}, SKU:{{selectedItem.sku}}</span>
                </span>
              </div>
            </span>
          </v-card-text>
        </v-card>
        <v-card class="mt-3">
          <v-card-text>
            <h2>Log for {{ tag }}</h2>
            <div v-for="(item, index) in this.tagLog" :key="index">
              {{item.type}} PL-{{ item.assetId }} @ Station: {{ item.stationId }} on {{ item.createdAt }}
              <hr>
            </div>
          </v-card-text>
        </v-card>
        <v-btn class="mt-3" block color="success" @click="confirm" x-large>Search</v-btn>
      </span>
    </v-container>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      deleteDialog: false,
      deleteConfirmed: true,
      loader: true,
      scanLoader: false,
      confirmMode: false,
      snackObj: {
        state: false,
        color: '',
        text: ''
      },

      max25chars: v => v.length <= 25 || 'Input too long!',
      editMode: false,
      data: {device: {}},
      singular: "Device",
      singularLower: "device",
      plural: "Devices",
      pluralLower: "devices",
      isEditable: false,
      employees: [],
      steps: ["Step 1: Enter the tags into the bucket", "Step 2: Select the product", "Step 3: Confirm"],
      instruction: "",
      tag: "TG102",
      productSearchTerm: "",
      productSearchResults: [],
      loadingSearchProduct: false,
      noSearchResults: false,
      selectedItem: null,
      tagLog: []
    }
  },
  async mounted(){
    try {
     console.log("RFID Registration Process Mounted")
     this.instruction = 0
    } catch (error) {
      console.error(error)
      this.snack(error.msg || error, "error");
    } finally {
      this.loader = false;
    }
  },
  computed: {
    ...mapGetters(["getEndpoint", "getRFIDEndpoint", "isAllowed", "getGlobalValue", 'getStationId'])
  },
  methods: {
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.state = true;
      this.snackObj.color = color;
    },
    nextStep(){
      this.instruction++
    },
    confirmA(){
      this.confirmMode = true
    },
    reset(){
      this.clearProductSearchResults()
      this.selectedItem = null,
      this.tags = []
      this.confirmMode = false
    },
    async scan(){
      try {
        this.loader = true
        let res = await axios.get(`${this.getRFIDEndpoint}/api/v1rfid/requestStationScan/${this.getStationId}`);
        if(res.data.error) throw res.data.error
        this.reset()
      } catch (error) {
        console.error(error)
        this.snack(error, "error")
      } finally{
        this.loader = false
      }
    },
    async confirm(){
      try {
        this.loader = true
        let res = await axios.post(`${this.getRFIDEndpoint}/api/v1rfid/tagLog`, {tagId: this.tag});
        if(res.data.error) throw res.data.error
        this.tagLog = res.data.data
        console.log(this.tagLog)
      } catch (error) {
        console.error(error)
        this.snack(error, "error")
      } finally{
        this.loader = false
      }
    },
    selectItem(item){
      this.clearProductSearchResults()
      this.selectedItem = item
    },
    async searchProduct(){
      try {
        if(this.productSearchTerm){
          this.loadingSearchProduct = true;
          let res = await axios.get(`${this.getEndpoint}/api/products/searchByAllVariationsNoLimit?val=${encodeURIComponent(this.productSearchTerm)}`);
          if(res.data.error) throw res.data.error
          this.productSearchResults = res.data.data
          if(this.productSearchResults.length == 0) this.noSearchResults = true
          else this.noSearchResults = false
        }
      } catch (error) {
        console.error(error)
        this.snack(error, "error")
      }finally {
        this.loadingSearchProduct = false;
      }
    },
    clearProductSearchResults(){
      this.productSearchResults = []
      this.productSearchTerm = ""
      this.noSearchResults = false
    },
  }
}
</script>
